import { ENABLE_STAGING_SETTING } from '@src/constants';

const isGW = response => {
  return response.hasOwnProperty('status');
};

/**
 *
 * @param request {Json}
 * @param reject
 * @param rootAddress
 * @return {{
 *   getAccountState
 * }}
 */
export default function(request, reject, rootAddress) {
  var service = {};
  /**
   获得基本信息
   请求方法: GET, POST
   请求示例: http://<domain>/webapp/mbsubscribe231101/get_config

   响应示例:

   {
      "code": 1,
      "status": 1,
      "msg": "",
      "message": "",
      "data": {
          "total": 0,
          "session_id": "QMthOsoLw4TteWJzdMupD4Kd80wtf43Mdi6SPnvn",
          "request_id": "8a20adba570042c127b8622cdcfa671bb67d26d1"
      }
   }
   */
  service.getConfig = function() {
    return request.post(rootAddress + '/webapp/mbsubscribe231101/get_config', {}).then(response => {
      if (response.status === 1 /* 成功 */) {
        /**
         {
          "data{}": {
            "total": "预约总数"
          }
        }
         */
        return response.data;
      }
      /**
       [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }]
       */
      return reject(response);
    });
  };
  /**
   发送邮件验证码
   请求方法: GET, POST
   请求示例: http://<domain>/webapp/mbsubscribe231101/get_email_code?email=495794424@qq.com&lang=cht

   响应示例:

   {
      "code": 1,
      "status": 1,
      "msg": "",
      "message": "",
      "data": {
          "session_id": "QMthOsoLw4TteWJzdMupD4Kd80wtf43Mdi6SPnvn",
          "request_id": "c1a8dcce88a4ad66ba789effb49e503b2cacd50b"
      }
   }
   */
  service.getEmailCode = function(params) {
    return request
      .post(rootAddress + '/webapp/mbsubscribe231101/get_email_code', {
        ...params
        // email: email /*  邮箱 */
      })
      .then(response => {
        if (response.status === 1 /* 成功 */) {
          /**
         {
          "data{}": []
        }
         */
          return response.data;
        }
        /**
       [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10103",
        "description": "邮箱为空"
      }, {
        "code": "-10104",
        "description": "邮箱格式错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-20101",
        "description": "邮箱格式错误"
      }, {
        "code": "-20102",
        "description": "该邮箱已预约"
      }]
       */
        return reject(response);
      });
  };
  /**
   预约
   请求方法: GET, POST
   请求示例: http://<domain>/webapp/mbsubscribe231101/subscribe?email=495794424@qq.com&code=456123

   响应示例:

   {
      "code": 1,
      "status": 1,
      "msg": "",
      "message": "",
      "data": {
          "session_id": "QMthOsoLw4TteWJzdMupD4Kd80wtf43Mdi6SPnvn",
          "request_id": "ca8f5850a1a856d47aea2b926d5a58dbd6788335"
      }
   }
   */
  service.subscribe = function(email, code, utm_source, pass_check, subscribe_duration_time) {
    return request
      .post(rootAddress + '/webapp/mbsubscribe231101/subscribe', {
        email: email /*  邮箱 */,
        code: code /*  邮箱验证码 */,
        utm_source: utm_source /*  来源 */,
        pass_check: pass_check,
        subscribe_duration_time: subscribe_duration_time // 预约经历时间
      })
      .then(response => {
        if (response.status === 1 /* 成功 */) {
          /**
         {
          "data{}": []
        }
         */
          return response.data;
        }
        /**
       [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-20102",
        "description": "该邮箱已预约"
      }]
       */
        return reject(response);
      });
  };
  service.downloadStatus = function() {
    return request.post(rootAddress + '/webapp/mbsubscribe231101/download_status', {}).then(response => {
      if (response.status === 1 /* 成功 */) {
        /**
        {
          "data{}": []
        }
            */
        return response.data;
      }

      return reject(response);
    });
  };
  service.getCountdownMsg = function() {
    return request.post(rootAddress + '/webapp/cbdlcyr241107/get_countdown_msg', {}).then(response => {
      if (response.status === 1 /* 成功 */) {
        /**
        {
          "data{}": {
            "bottom_left_red_point_delay_seconds": "下左红点延迟秒数",
            "bottom_right_red_point_delay_seconds": "下右红点延迟秒数",
            "countdown": "倒计时剩余总秒数",
            "countdown_doubling": "倒计时倍数",
            "is_begin": "是否已经开始",
            "red_point_delay_seconds": "红点再现延迟秒数",
            "top_left_red_point_delay_seconds": "上左红点延迟秒数",
            "top_min_red_point_delay_seconds": "上中红点延迟秒数",
            "top_right_red_point_delay_seconds": "上右红点延迟秒数"
          }
        }
            */
        return response.data;
      }
      return reject(response);
    });
  };
  service.area = '';
  service.getArea = function() {
    if (service.area) {
      return Promise.resolve(service.area);
    }
    return request.post('//pl-api.amazingseasun.com/webapp/official/proxy?uri=seasun/ext/getIpArea', {}).then(data => {
      service.area = data.data.areacode;
      return data.data.areacode;
    });
  };
  /**
		获得开放下载情况
		请求方法: GET, POST
		请求示例: http://<domain>/webapp/mbsubscribe231101/download_status

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "download_status": 0,
	        "session_id": "yv6RkaxehYWmBHiKgyGEeQRqoB2q6aNYR6mZcaid",
	        "request_id": "b5fce799f32cd62c3ae1955184a6cd2919b18d7a"
	    }
	 }
		*/
  service.downloadStatus = function() {
    return request.post(rootAddress + '/webapp/mbsubscribe231101/download_status', {}).then(response => {
      if (response.status === 1 /* 成功 */) {
        /**
        {
          "data{}": {
            "download_status": "下载开放情况"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		获得官网基础信息
		请求方法: GET, POST
		请求示例: http://<domain>/webapp/mbsubscribe231101/gw_config

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "account": "",
	        "is_in_subscribe_code_time": 0,
	        "is_in_open_download_time": 0,
	        "is_game_open_get_code_status": 0,
	        "session_id": "Th00Ug3m6SCy7mRWtnXgHqcuSkpog5AWjCYIgspY",
	        "request_id": "6acb702656748962ff11123df3cee640607cb131"
	    }
	 }
		*/
  service.gwConfig = function() {
    const params = {};
    // 是否开启灰度环境配置
    if (ENABLE_STAGING_SETTING) {
      params.is_huidu = 'huidu_test';
    }
    return request.post(rootAddress + '/webapp/mbsubscribe231101/gw_config', params).then(response => {
      if (response.status === 1 /* 成功 */) {
        /**
        {
          "data{}": {
            "account": "登录邮箱/seasun账号（open_down_load为1是seasun账号，为0是登录邮箱号）",
            "is_in_subscribe_code_time": "是否在预约发码阶段（1：是，0：否）",
            "is_in_open_download_time": "是否开启游戏下载（1：是，0：否）",
            "is_game_open_get_code_status": "下载阶段是否开启福利码发放（1：是，0：否）"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10402",
        "description": "请先登录"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		官网预约
		请求方法: GET, POST
		请求示例: http://<domain>/webapp/mbsubscribe231101/subscribe_by_gw?email=4957944242@qq.com&code=123123&subscribe_duration_time=50&utm_source=123123

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "is_new": 1,
	        "session_id": "0xKiP7vw3p65ugi3qAjDSO0nnA0hR5dqWfKDTdEV",
	        "request_id": "e8a28230eb2a9140c3d3aeda05459be745e723ba"
	    }
	 }
		*/
  service.subscribeByGw = function(code, email, utm_source, subscribe_duration_time) {
    return request
      .post(rootAddress + '/webapp/mbsubscribe231101/subscribe_by_gw', {
        code: code /*  邮箱验证码 */,
        email: email /*  邮箱 */,
        utm_source: utm_source /*  渠道来源 */,
        subscribe_duration_time: subscribe_duration_time /*  预约经历时长（单位为秒） */
      })
      .then(response => {
        if (response.status === 1 /* 成功 */) {
          /**
        {
          "data{}": {
            "is_new": "是否首次预约（1-是，0-否）"
          }
        }
        		*/
          return response.data;
        }
        /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10103",
        "description": "邮箱为空"
      }, {
        "code": "-10104",
        "description": "邮箱格式错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-20101",
        "description": "邮箱格式错误"
      }, {
        "code": "-20102",
        "description": "该邮箱已预约"
      }, {
        "code": "-20104",
        "description": "验证码错误，请重新输入"
      }, {
        "code": "-20105",
        "description": "未知错误"
      }, {
        "code": "-20107",
        "description": "验证码已过期，请重新获取验证码"
      }]
      		*/
        return reject(response);
      });
  };
  /**
		获得预约福利码
		请求方法: GET, POST
		请求示例: http://<domain>/webapp/mbsubscribe231101/get_code_in_subscribe

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "code": "dd675ddd4c04519330c4f677174d1ca0",
	        "session_id": "Th00Ug3m6SCy7mRWtnXgHqcuSkpog5AWjCYIgspY",
	        "request_id": "2954fb6f71d51411ba4799af81326a706d2a1548"
	    }
	 }
		*/
  service.getCodeInSubscribe = function() {
    const params = {};
    // 是否开启灰度环境配置
    if (ENABLE_STAGING_SETTING) {
      params.is_huidu = 'huidu_test';
    }
    return request.post(rootAddress + '/webapp/mbsubscribe231101/get_code_in_subscribe', params).then(response => {
      if (response.status === 1 /* 成功 */) {
        /**
        {
          "data{}": {
            "code": "福利码"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-20109",
        "description": "不在预约领取福利码阶段无法获得福利码"
      }, {
        "code": "-20110",
        "description": "福利码不足，请稍后重试！"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		获得下载阶段福利码
		请求方法: GET, POST
		请求示例: http://<domain>/webapp/mbsubscribe231101/get_code_in_down_load

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "code": "dd675ddd4c04519330c4f677174d1ca0",
	        "session_id": "Th00Ug3m6SCy7mRWtnXgHqcuSkpog5AWjCYIgspY",
	        "request_id": "2954fb6f71d51411ba4799af81326a706d2a1548"
	    }
	 }
		*/
  service.getCodeInDownLoad = function() {
    const params = {};
    // 是否开启灰度环境配置
    if (ENABLE_STAGING_SETTING) {
      params.is_huidu = 'huidu_test';
    }
    return request.post(rootAddress + '/webapp/mbsubscribe231101/get_code_in_down_load', params).then(response => {
      if (response.status === 1 /* 成功 */) {
        /**
        {
          "data{}": {
            "code": "福利码"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-20108",
        "description": "未到下载阶段无法获得福利码"
      }, {
        "code": "-20110",
        "description": "福利码不足，请稍后重试！"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		退出登录
		请求方法: GET, POST
		请求示例: http://<domain>/webapp/mbsubscribe231101/logout

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "session_id": "riRirWogbUtsC3rpoyrr4Q5LWKQh9numgwQwoprj",
	        "request_id": "5d78e9530b508d24bbd408d313de33dbeaf98847"
	    }
	 }
		*/
  service.logout = function() {
    return request.post(rootAddress + '/webapp/mbsubscribe231101/logout', {}).then(response => {
      if (response.status === 1 /* 成功 */) {
        /**
        {
          "data{}": []
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }]
      		*/
      return reject(response);
    });
  };
  return service;
}
